import { getLoginToken, getFileServerInfo } from 'Tyan/public'

const handleServerError = (xhr) => {
	return undefined
	// let message = xhr.statusText
	// return message
}

function createCORSRequest(method, url) {
	let xhr = new XMLHttpRequest()
	if ('withCredentials' in xhr) {
		// XHR for Chrome/Firefox/Opera/Safari.
		xhr.open(method, url, true)
	} else if (typeof XDomainRequest !== 'undefined') {
		// XDomainRequest for IE.
		xhr = new XDomainRequest()
		xhr.open(method, url)
	} else {
		// CORS not supported.
		xhr = null
	}
	xhr.setRequestHeader("Authorization", 'TS ' + getLoginToken())
	return xhr
}

/**
 * 20210119 add parametor:type: undefined(附件文件，默认)/'rt'(富文本附件)
 * @param {*} param0 
 */
export const uploadToServer = ({ type, blob, onSuccess, onError, onProgress, event, eventData, param }) => {
	// const url = '//jsonplaceholder.typicode.com/posts'
	// const url = 'http://a.com:89/shhl/comm/UploadFile'
	const url = type === 'rt'
		? getFileServerInfo().rtAttachmentUploadPath
		: getFileServerInfo().fileUploadPath

	const fileField = 'file'

	let throttle = false

	const options = {
		onProgress: (e) => {
			if (!e.lengthComputable || throttle) return

			throttle = true
			setTimeout(() => {
				throttle = false
			}, 16)

			onProgress && onProgress(typeof e.percent === 'number' ? e.percent : (e.loaded / e.total) * 100)
		},

		onLoad: xhr => {
			if (!/^2|1223/.test(xhr.status)) {
				onError && onError(handleServerError(xhr))
				return
			}

			let value = xhr.responseText || xhr.response

			if (value instanceof Error) {
				onError && onError(value.message)
				return
			}

			const val = JSON.parse(value)
			val.errorMessage && onError && onError(val.errorMessage)

			!val.errorMessage && onSuccess && onSuccess(val)
		},

		onError: e => { onError && onError(handleServerError(e.currentTarget)) }
	}

	const data = new FormData()

	data.append(fileField, blob)
	getLoginToken() && data.append("token", getLoginToken())
	eventData && Object.entries(eventData).forEach(([key, value]) => data.append(key, value))
	event && data.append('event', event)

	param && data.append('param', param)

	const xhr = createCORSRequest('post', url)
	// xhr.withCredentials = withCredentials

	onProgress && xhr.upload.addEventListener('progress', options.onProgress)
	onError && xhr.addEventListener('error', options.onError)

	xhr.addEventListener('load', e => options.onLoad(e.currentTarget))

	xhr.send(data)
	return xhr
}

export const getDownloadUrl = (value, downloadAllProp) => {
	const { FID, downloadFileName, FileName, FileExt, downloadAll } = (() => (
		Array.isArray(value)
			? {
				FID: JSON.stringify(value.map(({ FID, FileName, FileExt }) => ({ FID, filename: FileName ? `${FileName}${FileExt}` : undefined }))),
				downloadAll: downloadAllProp
			}
			: value || {}
	))()

	if (!FID) return null
	const { fidKey } = Tyan.sysConfig.files
	const fileServerInfo = getFileServerInfo()

	return fileServerInfo.download
		? fileServerInfo.getMockDownloadUrl(value, downloadAll)
		// : downloadFileName
		// 	? `${fileServerInfo.fileDownloadFilePath}${fidKey ? encodeURIComponent(Tyan.utility.encryptDES(FID, fidKey)) : FID}/${downloadFileName}`
		: [
			`${fileServerInfo.fileDownloadPath}${fidKey ? encodeURIComponent(Tyan.utility.encryptDES(FID, fidKey)) : FID}`,
			`${getLoginToken() && `&token=${getLoginToken()}` || ''}`,
			`${downloadFileName ? `&filename=${downloadFileName}` : FileName ? `&filename=${FileName}${FileExt}` : ''}`,
			`${downloadAll ? `&downloadall=${downloadAll}.zip` : ''}`
		].join('')
	// : `${fileServerInfo.fileDownloadPath}${FID}${FileName && `&filename=${FileName}${FileExt || ''}` || ''}`
}

export const getRtaUrl = DP => {
	const fileServerInfo = getFileServerInfo()
	return DP
		? fileServerInfo.download
			? fileServerInfo.getMockDownloadUrl({ FID: DP, FileExt: '' })
			: `${fileServerInfo.rtAttachmentDownloadPath}${encodeURIComponent(DP)}`
		: null
}

export const downloadFromServer = ({ value, onSuccess, onError, onProgress }) => {
	const url = getDownloadUrl(value)

	// 方案一：直接返回服务器url
	// onSuccess && onSuccess(url)
	// return null

	// 方案二：下载数据到本地后生成本地URL使用
	let throttle = false

	const options = {
		onProgress: (e) => {
			if (!e.lengthComputable || throttle) return

			throttle = true
			setTimeout(() => {
				throttle = false
			}, 16)

			onProgress && onProgress(typeof e.percent === 'number' ? e.percent : (e.loaded / e.total) * 100)
		},

		onLoad: xhr => {
			if (!/^2|1223/.test(xhr.status)) {
				onError && onError(handleServerError(xhr))
				return
			}

			//   if (xhr.status == 200) {
			//     //if ( xhr.response instanceof Blob )
			//     var link = document.createElement('a')
			//     // var file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			//     link.href = window.URL.createObjectURL(xhr.response)
			//     link.download = value.FileName || getUuid()
			//     link.click()

			const blob = xhr.response

			// 返回错误信息
			if (blob.type === 'application/json') {
				const fr = new FileReader()
				fr.onloadend = (e) => {
					// console.log(e.target.result)
					onError && onError(e.target.result)
				}
				fr.readAsText(blob)
				return
			}

			// console.log(blob)

			if (onSuccess) {
				const url = window.URL.createObjectURL(blob)
				// const url = window.URL.createObjectURL(new File([blob], `${value.FileName && `${value.FileName}${value.FileExt}` || `${value.FID}`}`, { type: blob.type }))
				// console.log('debug url:', url)
				setTimeout(() => window.URL.revokeObjectURL(url), 3000000)
				onSuccess(url)
			}
		},

		onError: e => {
			onError && onError(handleServerError(e.currentTarget))
		}
	}

	const xhr = createCORSRequest('get', url)
	xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
	xhr.responseType = "blob"
	// onProgress && xhr.addEventListener('progress', options.onProgress)
	// onError && xhr.addEventListener('error', options.onError)
	xhr.addEventListener('progress', options.onProgress)
	xhr.addEventListener('error', options.onError)
	xhr.addEventListener('load', e => options.onLoad(e.currentTarget))
	xhr.send()

	return xhr
}
